module.exports = __webpack_public_path__ + "img/comingsoon.57c34077.gif";